import {GeoCoords, QGraph} from './geo-and-movement.interfaces';
import {Dict} from './common.interfaces';
import {ObeliskImportance, ObeliskType} from './obelisks.enums';
import {QuestUser} from './social.interfaces';
import {Pathway, ObeliskComment} from './map-markings.interfaces';

export interface Obelisk {
  uuid?: string;
  name: string;
  subTitle?: string;
  creator?: QuestUser;
  description?: string;
  location?: GeoCoords;
  svg?: string;
  type: ObeliskType;
  status?: 'place' | 'marker' | 'hidden';
  category?: string;
  subCategory?: string;
  importance?: ObeliskImportance | string;
  rewardsExp?: number;
  rewardsTokens?: number;
  address?: string;
  approved?: boolean;
  zone?: ObeliskZone;
  config?: {
    pathways?: Pathway[];
    comments?: ObeliskComment[];
    [key: string]: any;
  };
  createdAt?: Date;
  updatedAt?: Date;
  images?: ObeliskImage[];
  keywords?: string;
  generated?: boolean;

  createdAgo?: string;
  updatedAgo?: string;
}

export interface Marker {
  uuid?: string;
  name: string;
  creator?: QuestUser;
  description?: string;
  location: GeoCoords;
  status?: 'marker';
  address?: string;
  config?: Dict<any>;
  createdAt?: Date;
  updatedAt?: Date;
  additionalData?: Dict<any>;
  distance?: number;
  images?: ObeliskImage[];
}

export interface ObeliskImage {
  uuid: string;
  uri?: string;
  saved?: boolean;
  description?: string;
  order?: number;
}

export interface ObeliskZoneCircle {
  type: 'circle';
  radius: number; // in meters
}

export interface RelativeCoords {
  lngDiff: number;
  latDiff: number;
}

export interface ObeliskZonePolygon {
  type: 'polygon';
  vertices: RelativeCoords[];
  absolutePolygon?: QGraph;
}

export type ObeliskZone = ObeliskZoneCircle | ObeliskZonePolygon;

export const isObeliskZoneCircle = (zone: ObeliskZone): zone is ObeliskZoneCircle => zone.type === 'circle';
